import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
export var setCompliantLocalStorageItem = createAction("".concat(reduxKey, "/SET_ITEM"), function (payload) { return payload; });
//# sourceMappingURL=actions.js.map